import { Dock } from './../../models/Dock';
import { Injectable, EventEmitter } from '@angular/core';
import * as three from 'three';
import OrbitControls from 'three-orbitcontrols';
import { HttpClient } from '@angular/common/http';
import { Group, Mesh, TextGeometryParameters } from "three";

@Injectable()
export class ThreeProvider {

  clickListener = new EventEmitter()
  private materials: any = {}
  private objectLoader = new three.ObjectLoader()
  private raycaster = new three.Raycaster()
  private mouse = new three.Vector2()
  private dom: any
  private width: any = 500
  private height: any = 500
  private renderer: any
  private scene: any
  private camera: any
  private prevTime: any
  private request: any
  private el: any
  private element: any

  private truck: any
  private container_wagon: any

  private fontOptions: any;

  constructor(private http: HttpClient) { }

  loadAll() {
    this.dom = document.createElement('div');
    
    this.initFont();
    this.initMaterials();

    this.http.get('assets/json/app.json').subscribe((data: any) => {
      this.load(data);
      this.setSize(this.element.nativeElement.clientWidth, this.element.nativeElement.clientHeight);
      this.play();
      if (this.el.hasChildNodes()) {
        this.el.removeChild(this.el.firstChild);
      }
      this.el.appendChild(this.dom);
    });
  }

  setMainEl(el) {
    this.el = el
  }

  setElement(el) {
    this.element = el
  }

  private load(json) {
    this.renderer = new three.WebGLRenderer({ antialias: true });
    this.renderer.setClearColor(0x000000);
    this.renderer.setPixelRatio(window.devicePixelRatio);

    if (json.project.gammaInput) {
      this.renderer.gammaInput = true;
    }

    if (json.project.gammaOutput) {
      this.renderer.gammaOutput = true;
    }

    if (json.project.shadows) {
      this.renderer.shadowMap.enabled = true;
    }

    if (this.dom.hasChildNodes()) {
      this.dom.removeChild(this.dom.firstChild);
    }

    this.dom.appendChild(this.renderer.domElement);

    this.setScene(this.objectLoader.parse(json.scene));
    this.setCamera(this.objectLoader.parse(json.camera));

    this.initFont();

    this.addClickHandlers()

    this.setControls()

    this.initVehicles()
  }

  initVehicles() {
    this.truck = this.scene.getObjectByProperty('uuid', '2F9FECE6-6165-4125-B5CF-3EE767BF0725');
    this.truck.visible = false;

    this.container_wagon = this.scene.getObjectByProperty('uuid', '642F6D35-3191-4E1B-943A-1EDFAD335BD1');
    this.container_wagon.visible = false;
  }

  setControls() {
    let controls = new OrbitControls(this.camera, this.renderer.domElement)
    controls.minPolarAngle = 0;
    controls.maxPolarAngle = Math.PI / 2;

    controls.minDistance = 20
    controls.maxDistance = 90
  }

  addClickHandlers() {
    let onDocumentTouchStart = (event) => {

      event.preventDefault();

      event.clientX = event.touches[0].clientX;
      event.clientY = event.touches[0].clientY;
      onDocumentMouseDown(event);
    }


    let onDocumentMouseDown = (event) => {
      event.preventDefault();

      this.mouse.x = (event.clientX / this.renderer.domElement.clientWidth) * 2 - 1;
      this.mouse.y = - (event.clientY / this.renderer.domElement.clientHeight) * 2 + 1;

      this.raycaster.setFromCamera(this.mouse, this.camera);
      var intersects = this.raycaster.intersectObjects(this.scene.children);
      if (intersects.length > 0) {
        let obj = intersects[0]
        this.updateDockByUuid(obj.object.uuid)
      }
    }

    let onWindowResize = () => {

      this.setSize(this.element.nativeElement.clientWidth, this.element.nativeElement.clientHeight);

    }

    this.dom.addEventListener('mousedown', onDocumentMouseDown, false);
    this.dom.addEventListener('touchstart', onDocumentTouchStart, false);
    window.addEventListener('resize', onWindowResize, false);
  }

  toggle(dockModel: Dock) {
    if (this.scene && dockModel.uuid) {
      let dockObject = this.scene.getObjectByProperty('uuid', dockModel.uuid);

      if (dockModel.current && dockModel.current.status == 2) {

        dockObject.material = this.materials.orange
        this.addVehicle(dockObject, dockModel);

      } else if (dockModel.current && dockModel.current.status == 1) {

        dockObject.material = this.materials.red
        this.addVehicle(dockObject, dockModel);

      } else {

        dockObject.material = this.materials.green
        this.removeVehicle(dockObject, dockModel);

      }
    }
  }

  private initFont() {
    if (!this.fontOptions) {
      let font = new three.FontLoader()
      font.load('/assets/fonts/Roboto Black_Regular.json', (font) => {
        this.fontOptions = {
          font: font,
          size: 0.4,
          height: 0.01,
          curveSegments: 1,
          bevelEnabled: false,
          bevelThickness: 0.01,
          bevelSize: 0.5
        }
      });
    }
  }

  private initMaterials() {
    // if (!this.materials) {
      this.materials = {
        green: new three.MeshStandardMaterial(),
        red: new three.MeshStandardMaterial(),
        orange: new three.MeshStandardMaterial(),
        gray: new three.MeshStandardMaterial(),
        black: new three.MeshStandardMaterial(),
      };

      this.materials.green.emissive.setStyle('#50e184')
      this.materials.red.emissive.setStyle('#ff373b')
      this.materials.orange.emissive.setStyle('#f6b84e')
      this.materials.gray.emissive.setStyle('#626b7c')
      this.materials.black.emissive.setStyle('#000000')
    // }
  }

  private addVehicle(dock: Mesh, dockModel: Dock): void {
    this.initFont();
    this.removeVehicle(dock, dockModel);

    let vehicleTypeAndNumber = this.getVehicleTypeAndNumber(dockModel);

    let X = (dock.position.z < 0 ? dock.position.x - 19.9 : dock.position.x + 19.9);
    let Z = (dock.position.z < 0 ? dock.position.z + 1 : dock.position.z - 1);
    let rotate = (dock.position.z < 0 ? true : false);    
    
    
    let isTruck = vehicleTypeAndNumber && (vehicleTypeAndNumber.type == 'trekker' || !vehicleTypeAndNumber.type);
    
    let copy = isTruck ? this.truck.clone() : this.container_wagon.clone();
    if(!isTruck) {
      Z = (dock.position.z < 0 ? dock.position.z + 1.8 : dock.position.z - 1.8);      
    }

    copy.position.setX(X) // links / rechts
    copy.position.setZ(Z) // vooruit / achteruit
    if (rotate) {
      copy.rotation.y = Math.PI
    }
    copy.visible = true
    
    copy.uuid = `${dock.uuid}_vehicle`;

    // START: SETS COLORS BASED ON TRANSPORTING COMPANY
    let company = (vehicleTypeAndNumber.type ? this.getCompany(dockModel) : 'externe');
    copy.children.forEach((child: Mesh) => {
      if(child.name === 'Box 1 - Truck') {
        switch (company) {
          case 'dhb':
            child.material = this.materials.green            
            break;
          case 'externe':
            child.material = this.materials.gray
            break;
          default:
            child.material = this.materials.red
            break;
        }
      }
    });
    // END: SETS COLORS BASED ON TRANSPORTING COMPANY

    // START: SETS VEHICLE NUMBER ON TOP OF ROOF
    if(vehicleTypeAndNumber && vehicleTypeAndNumber.number) {
      let objName = copy.name
      let options: TextGeometryParameters = this.fontOptions

      let code = vehicleTypeAndNumber.number;
      if (code != null) {
        code = code.toString();
        if (objName == 'Bakwagen simpel') {
          options.size = (code.length > 5 ? 0.20 : 0.30)
        }
        if (code.length > 5) {
          options.size = 0.28
        }
        if(code.indexOf('-') !== -1) {
          options.size = 0.24;
        }
      }
      copy.children.forEach((child: Mesh) => {
        if (child.name == 'Box 1 - text'){
          if(code) {
            let geometry = new three.TextGeometry(code, options)
            geometry.rotateX(0)
            geometry.rotateY(1.57)
            geometry.rotateZ(1.57)

            child.geometry = geometry
            child.visible = true
          } else {
            child.visible = false
          }
        }
      })
    } else {
      copy.children.forEach((child: Mesh) => {
        if (child.name == 'Box 1 - text') {
          child.visible = false
        }
      });
    }
    // STOP: SETS VEHICLE NUMBER ON TOP OF ROOF

    this.scene.add(copy)
  }

  private removeVehicle(dock: Mesh, dockModel: Dock) {
    let mesh = this.scene.getObjectByProperty('uuid', `${dock.uuid}_vehicle`);

    if (mesh) {
      // @TODO: wordt bij iedere verwijder actie voor alle voertuigen uitgevoerd, raar??

      // console.log(`${dock.uuid}_vehicle`)
      // console.log(mesh);
      // mesh.geometry.dispose();
      // mesh.material.dispose();
      this.scene.remove(mesh)
      // mesh = []
    }
  }

  private getCompany(dockModel: Dock) {
    let company;
    if (dockModel.current && dockModel.current.truck) {
      if (dockModel.current.truck.transporter == 0) {
        company = 'tielbeke'
      } else if (dockModel.current.truck.transporter == 1) {
        company = 'dhb'
      }
    } else if (dockModel.current && !dockModel.current.truck && dockModel.current.trailer) {
      if (dockModel.current.trailer.transporter == 0) {
        company = 'tielbeke'
      } else if (dockModel.current.trailer.transporter == 1) {
        company = 'dhb'
      }
    }
    return company;
  }

  private getVehicleTypeAndNumber(dockModel: Dock): {type: string, number: string} {
    let type, current_type, number;
    if (dockModel.current && dockModel.current.truck) {
      current_type = dockModel.current.truck.type
    } else if (dockModel.current && !dockModel.current.truck && dockModel.current.trailer) {
      current_type = dockModel.current.trailer.type
    }

    if (current_type == 0) {
      type = 'truck';

      if (dockModel.current.truck && dockModel.current.trailer) {
        number = `${dockModel.current.truck.code}-${dockModel.current.trailer.code}`;
      }
      else {
        if (dockModel.current.trailer) {
          number = dockModel.current.trailer.code
        }
        else if (dockModel.current.truck) {
          number = dockModel.current.truck.code
        }
      }
    }
    else if (current_type == 2) {
      type = 'container_wagon';

      if (dockModel.current.trailer) {
        number = dockModel.current.trailer.code
      }
      else if (dockModel.current.truck) {
        number = dockModel.current.truck.code
      }
    }
    else if (current_type == 1) {
      type = 'trekker';

      if (dockModel.current.trailer) {
        number = dockModel.current.trailer.code
      }
      else if (dockModel.current.truck) {
        number = dockModel.current.truck.code
      }
    }

    return { type, number };
  }

  updateDockByUuid(uuid: string) {
    this.clickListener.emit(uuid)
  }


  private setCamera(value) {
    this.camera = value;
    this.camera.aspect = this.width / this.height;
    this.camera.rotation.set(-90, 20, 0)
    // this.camera.setZoom()
    // this.camera.position.setX

    this.camera.position.x = 0;
    this.camera.position.y = 48;
    this.camera.position.z = 0;
    // this.camera.fov

    this.camera.updateProjectionMatrix();
  }

  private setScene(value) {
    this.scene = value;
    this.scene.position.setZ(8)
  }

  private setSize = (width, height) => {
    this.element.width = width;
    this.element.height = height;

    this.width = width;
    this.height = height;

    if (this.camera) {
      this.camera.aspect = this.width / this.height;
      this.camera.updateProjectionMatrix();
    }

    if (this.renderer) {
      this.renderer.setSize(width, height);
    }
  }

  private play() {
    let animate = (time) => {
      this.request = requestAnimationFrame(animate);
      this.renderer.render(this.scene, this.camera);
      this.prevTime = time;
    }
    this.request = requestAnimationFrame(animate);
  }

}



// WEBPACK FOOTER //
// ./src/providers/three/three.ts